import styled from 'styled-components';
import { BsStarFill, BsStarHalf, BsStar } from 'react-icons/bs';

export const StarFull = styled(BsStarFill)`
  color: var(--yellow);

  font-size: ${props => props.size};

  &:nth-child(even) {
    margin: 0 10px;
  }
`;

export const StarHalf = styled(BsStarHalf)`
  color: var(--yellow);

  font-size: ${props => props.size};

  &:nth-child(even) {
    margin: 0 10px;
  }
`;

export const StarEmpty = styled(BsStar)`
  color: var(--yellow);

  font-size: ${props => props.size};

  &:nth-child(even) {
    margin: 0 10px;
  }
`;

export const NoRatingText = styled.p`
  width: 100%;

  text-align: center;
  font-size: 14px;
  color: var(--light-gray);
`;
